(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velano-opiniones"] && !Shopify.designMode) return;
  try {
    
  function velanoOpiniones(raiz) {
    raiz.querySelectorAll('[data-velano-op]').forEach(function (c) {
      if (c.dataset.listo) return;
      c.dataset.listo = '1';
      var pista = c.querySelector('[data-velano-op-pista]');
      var prev = c.querySelector('[data-velano-op-prev]');
      var next = c.querySelector('[data-velano-op-next]');
      if (!pista) return;
      function paso() {
        var li = pista.querySelector('li');
        return li ? li.getBoundingClientRect().width : pista.clientWidth;
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
    });
  }
  velanoOpiniones(document);
  document.addEventListener('shopify:section:load', function (e) { velanoOpiniones(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velano-resenas"] && !Shopify.designMode) return;
  try {
    
  function velanoIniciarCarrusel(carrusel) {
    if (carrusel.dataset.listo) return;
    carrusel.dataset.listo = '1';
    var pista = carrusel.querySelector('[data-velano-pista]');
    var anterior = carrusel.querySelector('[data-velano-anterior]');
    var siguiente = carrusel.querySelector('[data-velano-siguiente]');
    var puntos = carrusel.querySelector('[data-velano-puntos]');
    if (!pista) return;
    var tarjetas = pista.querySelectorAll('li');
    function paso() {
      return tarjetas.length ? tarjetas[0].getBoundingClientRect().width + 16 : pista.clientWidth;
    }
    if (puntos) {
      tarjetas.forEach(function (_, i) {
        var p = document.createElement('span');
        p.className = 'velano-resenas__punto' + (i === 0 ? ' is-activo' : '');
        puntos.appendChild(p);
      });
    }
    function actualizar() {
      if (!puntos) return;
      var i = Math.round(pista.scrollLeft / paso());
      puntos.querySelectorAll('span').forEach(function (p, j) {
        p.classList.toggle('is-activo', j === i);
      });
    }
    pista.addEventListener('scroll', function () {
      window.requestAnimationFrame(actualizar);
    });
    if (anterior) anterior.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: 'smooth' }); });
    if (siguiente) siguiente.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: 'smooth' }); });
  }
  document.querySelectorAll('[data-velano-carrusel]').forEach(velanoIniciarCarrusel);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-velano-carrusel]').forEach(velanoIniciarCarrusel);
  });

  } catch(e) { console.error(e); }
})();
})();
